interface MachPageLifecycle {
  env?: {
    isPageVisible?: boolean;
    [key: string]: unknown;
  };
  receiveEvent?: (event: string, data?: unknown) => void;
}

/**
 * Keep the H5 Mach visibility state and lifecycle events in one transaction.
 * A newly active route publishes its final visibility after the previous
 * route's passive-effect cleanup has finished.
 */
export function publishMachPageVisibility(
  mach: MachPageLifecycle | undefined,
  visible: boolean
): void {
  if (!mach) return;

  if (!mach.env) {
    mach.env = {};
  }
  mach.env.isPageVisible = visible;

  if (visible) {
    mach.receiveEvent?.('pageWillAppear', true);
    mach.receiveEvent?.('pageDidAppear', true);
  } else {
    mach.receiveEvent?.('pageWillDisappear', true);
    mach.receiveEvent?.('pageDidDisappear', true);
  }
}
